import React from "react";
import PropTypes from "prop-types";
import { changePassword } from "../../../apis/authentication-api/AuthenticationAPI";
//Limitless imports
import { useNotificationContext } from "@limitless/common/hooks";
import { validateChangePasswordForm } from "../../../utils/validators/ChangePasswordFormValidator";
import { INITIAL_FIELD } from "../../../utils/FieldValidators";
const ChangePasswordForm = ({
  children
}) => {
  const [loading, setLoading] = React.useState(false);
  const [newPassword, setNewPassword] = React.useState(INITIAL_FIELD);
  const [confirmPassword, setConfirmPassword] = React.useState(INITIAL_FIELD);
  const [oldPassword, setOldPassword] = React.useState(INITIAL_FIELD);
  const {
    addFailureNotification,
    addSuccessNotification
  } = useNotificationContext();
  const onFormSubmit = () => {
    setLoading(true);
    changePassword(oldPassword.value, newPassword.value, error => {
      setLoading(false);
      let success = true;
      if (error) {
        success = false;
        let notification = "Please enter correct Old Password";
        if (error.message !== "Incorrect username or password." && error.meaning) {
          notification = error.meaning;
        }
        addFailureNotification(notification);
      } else {
        addSuccessNotification("Password changed successfully");
      }
      if (success) {
        setNewPassword(INITIAL_FIELD);
        setConfirmPassword(INITIAL_FIELD);
        setOldPassword(INITIAL_FIELD);
      }
    });
  };
  const handleOldPasswordChange = value => {
    setOldPassword({
      value,
      pristine: false
    });
  };
  const handleConfirmPasswordChange = value => {
    setConfirmPassword({
      value,
      pristine: false
    });
  };
  const handleNewPasswordChange = value => {
    setNewPassword({
      value,
      pristine: false
    });
  };
  const {
    fieldErrors,
    isFormInvalid
  } = validateChangePasswordForm({
    newPassword,
    oldPassword,
    confirmPassword
  });
  return children({
    newPassword,
    oldPassword,
    confirmPassword,
    fieldErrors,
    isFormInvalid,
    onNewPasswordChange: handleNewPasswordChange,
    onConfirmPasswordChange: handleConfirmPasswordChange,
    onOldPasswordChange: handleOldPasswordChange,
    onFormSubmit,
    loading
  });
};
export default ChangePasswordForm;
ChangePasswordForm.propTypes = {
  children: PropTypes.func.isRequired
};